import type { Step } from 'react-joyride';
import type { FloatingOptions } from 'react-joyride';

export const TOUR_IDS = {
  ORGANIZATIONS_LIST: 'organizations-list',
  CREATE_ORGANIZATION: 'create-organization',
  ORGANIZATION_DETAIL: 'organization-detail',
  CREATE_TOURNAMENT: 'create-tournament',
  TOURNAMENT_STRUCTURE: 'tournament-structure',
  ENTRY_FEE_PRIZE: 'entry-fee-prize',
  WALLET: 'wallet',
} as const;

export type TourId = (typeof TOUR_IDS)[keyof typeof TOUR_IDS];

export type TourStepDefinition = {
  target: string;
  titleKey: string;
  contentKey: string;
  placement?: Step['placement'];
  skipBeacon?: boolean;
  /** Gap between target and tooltip (Joyride `offset`). */
  offset?: number;
  /** Page switches to this tab before the step (sent on `espotz-tour:before-step`). */
  switchTab?: string;
  /** Keep placement fixed (don't flip when space is tight). */
  disableFlip?: boolean;
  /** Extra scroll room above the target for top-placed tooltips (px). */
  topScrollRoom?: number;
  /** Highlight a different element than the tooltip anchor (Joyride `spotlightTarget`). */
  spotlightTarget?: string;
  /** Extend spotlight beyond a small anchor (e.g. label → pool cards below). */
  spotlightPadding?: Step['spotlightPadding'];
  /** Per-step Floating UI overrides (e.g. looser shift padding for top placement). */
  floatingOptions?: Partial<FloatingOptions>;
};

export type TourDefinition = {
  id: TourId;
  steps: TourStepDefinition[];
};

export type TourProgress = {
  completed: TourId[];
  skipped: TourId[];
};
